import { DenialSupportTable } from "@/components/Templates/DenialSupport";

const DenialSupportPage = () => {
  return <DenialSupportTable />;
};

export default DenialSupportPage;

